import { Box, HStack, Spinner, Text, VStack } from "native-base";
import CryptoJS from "crypto-js";
import { useSelector } from "react-redux";
import FileUploader from "../../../../../containers/fileUpload";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../../../../utils/fonts";
import { COLORS } from "../../../../../utils/colors";
import Dropdown from "../../../../../components/dropdown";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { getWorkflowAPI } from "../../../../../api/apis/workflow";
import {
  eventListingAPI,
  newEventListingAPI,
} from "../../../../../api/apis/event";
import { Toaster } from "../../../../../components/toaster";
import SearchableSelectDropdown from "../../../../../components/searchableDropDown";
import NewTextAreaField from "../../../../../components/textArea/newTextArea";
import ToggleButton from "../../../../../components/toggle";
import InputField from "../../../../../components/input";
import { hasPermission } from "../../../../../utils/permission";
import { getVendorEventsAPI } from "../../../../../api/apis/vendor";
import ViewUploadImageCards from "../../../../../containers/viewUploadImageCards";
import config from "../../../../../utils/config";

export const GeneralNotificationModal = forwardRef(
  (
    {
      data,
      setData,
      forceRemount,
      tabActiveButton,
      setTabActiveButton,
      scrollToTop = () => {},
    },
    ref
  ) => {
    const [selectedImageUrl, setSelectedImageUrl] = useState(data.url);
    const [selectedFile, setSelectedFile] = useState("");
    const [videoUrl, setVideoUrl] = useState(data.url);

    useEffect(() => {
      setSelectedImageUrl("");
      setSelectedFile("");
      setVideoUrl("");
      scrollToTop();
    }, [forceRemount]);

    const selectedUrl = () => {
      if (tabActiveButton === "Image") {
        return selectedFile;
      } else {
        return videoUrl;
      }
    };

    useImperativeHandle(ref, () => ({
      selectedUrl,
    }));

    const onFileChange = (file) => {
      let fileData = { ...data };
      fileData.people = file;
      setData(fileData);
    };

    const onFileChanges = (file) => {
      // let fileData = { ...data };
      // fileData.url = file;
      // setData(fileData);
      setSelectedFile(file);
      const imageUrls = Array.from(file).map((item) =>
        URL.createObjectURL(item)
      );
      setSelectedImageUrl(imageUrls);
    };

    const onDeleteImage = (ind) => {
      setSelectedImageUrl("");
      setSelectedFile("");
      // setData({
      //   ...data,
      //   url: "",
      // });
    };

    return (
      <VStack space={3} style={{ position: "relative" }}>
        <NewTextAreaField
          name="notification"
          value={data.text}
          onChange={(e, eName) => {
            let value = e.target.value;
            let detail = { ...data };
            detail["text"] = value;
            setData(detail);
          }}
          label="Notification"
          placeholder="Enter Notification"
          forceRemount={forceRemount}
        />
        <Text
          fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
          fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
          color={COLORS.ACCORDION_TITLE_COLOR}
          mt={3}
        >
          Upload Attendees Details
        </Text>
        <FileUploader
          files={data.people}
          setFiles={onFileChange}
          templates
          href={config.notificationPeople}
          forceRemount={forceRemount}
        />
        <ToggleButton
          options={["Image", "Video"]}
          activeButton={tabActiveButton}
          setActiveButton={(value) => {
            // let d = { ...data };
            // d.url = "";
            // setData(d);
            setTabActiveButton(value);
          }}
        />
        {tabActiveButton === "Image" ? (
          <>
            <FileUploader
              types=".jpg, .jpeg, .png"
              accept={["jpg", "jpeg", "png"]}
              files={selectedImageUrl}
              setFiles={onFileChanges}
              show={false}
              forceRemount={forceRemount}
            />
            <HStack flex={1} flexWrap={"wrap"}>
              {selectedImageUrl && (
                <ViewUploadImageCards
                  ind={0}
                  url={selectedImageUrl}
                  onDeleteImage={onDeleteImage}
                />
              )}
            </HStack>
          </>
        ) : (
          <InputField
            name="video_notification"
            value={videoUrl}
            placeholder="Enter your video link here"
            onChange={(e) => {
              let value = e.target.value;
              // let d = { ...data };
              // d.url = value;
              // setData(d);
              setVideoUrl(value);
            }}
            forceRemount={forceRemount}
          />
        )}
      </VStack>
    );
  }
);

export const EventNotificationModal = forwardRef(
  (
    {
      data,
      setData,
      forceRemount,
      tabActiveButton,
      setTabActiveButton,
      scrollToTop = () => {},
    },
    ref
  ) => {
    const activeTab = useSelector((state) => {
      return state.event.activeTab;
    });
    const toaster = Toaster();
    const [options, setOptions] = useState([]);
    const [label, setLabel] = useState("");
    const bytes = CryptoJS.AES.decrypt(
      sessionStorage.getItem("content"),
      config.userKey
    );
    const jsonString = bytes.toString(CryptoJS.enc.Utf8);
    const userInfo = JSON.parse(jsonString);
    const [selectedImageUrl, setSelectedImageUrl] = useState(data.url);
    const [selectedFile, setSelectedFile] = useState("");
    const [videoUrl, setVideoUrl] = useState(data.url);

    useEffect(() => {
      if (!hasPermission("VENDOR")) {
        getEventList();
      } else {
        getVendorEvents();
      }
      setLabel(activeTab === "event" ? "Event" : "MICE");
      setSelectedImageUrl("");
      setSelectedFile("");
      setVideoUrl("");
      scrollToTop();
    }, [activeTab, forceRemount]);

    const selectedUrl = () => {
      if (tabActiveButton === "Image") {
        return selectedFile;
      } else {
        return videoUrl;
      }
    };

    useImperativeHandle(ref, () => ({
      selectedUrl,
    }));

    const onFileChanges = (file) => {
      // let fileData = { ...data };
      // fileData.url = file;
      // setData(fileData);
      setSelectedFile(file);
      const imageUrls = Array.from(file).map((item) =>
        URL.createObjectURL(item)
      );
      setSelectedImageUrl(imageUrls);
    };

    const onDeleteImage = (ind) => {
      setSelectedImageUrl("");
      setSelectedFile("");
      // setData({
      //   ...data,
      //   url: "",
      // });
    };

    const getVendorEvents = async () => {
      let allEvents = [];
      let selectedActiveTab = activeTab;
      if (selectedActiveTab === "packages") {
        selectedActiveTab = "mice";
      }
      let res = await getVendorEventsAPI(
        "1",
        "10000",
        selectedActiveTab,
        "current"
      );
      if (res.error) {
        toaster(res.message, "error", "error");
        return;
      } else {
        res?.data?.data?.data[0]?.events?.map((item) => {
          allEvents.push({
            id: item._id,
            value: item._id,
            label: item.event_name,
          });
        });
      }
      setOptions(allEvents);
    };

    const getEventList = async () => {
      let allEvents = [];
      let user_id = "";
      if (
        !hasPermission("SEND_ALL_NOTIFICATION") &&
        userInfo &&
        userInfo.email
      ) {
        user_id = userInfo.email;
      }

      let res = await newEventListingAPI(
        activeTab,
        "1",
        "10000",
        "upcoming",
        user_id,
        "notification"
      );

      if (res.error) {
        toaster(res.message, "error", "error");
        return;
      } else {
        res?.data?.data?.data[0]?.events?.map((item) => {
          allEvents.push({
            id: item._id,
            value: item._id,
            label: item.event_name,
          });
        });
      }

      setOptions(allEvents);
    };

    return (
      <VStack space={5}>
        <Dropdown
          name="event_mice"
          dropItems={options}
          selectedValues={data.event_id}
          setSelectedValues={(value) => {
            let detail = { ...data };
            detail["event_id"] = value;
            setData(detail);
          }}
          label={label}
          placeholder={label}
        />
        <NewTextAreaField
          name="notification"
          value={data.text}
          onChange={(e, eName) => {
            let value = e.target.value;
            let detail = { ...data };
            detail["text"] = value;
            setData(detail);
          }}
          label="Notification"
          placeholder="Enter Notification"
          forceRemount={forceRemount}
        />
        <ToggleButton
          options={["Image", "Video"]}
          activeButton={tabActiveButton}
          setActiveButton={(value) => {
            // let d = { ...data };
            // d.url = "";
            // setData(d);
            setTabActiveButton(value);
          }}
        />
        {tabActiveButton === "Image" ? (
          <>
            <FileUploader
              types=".jpg, .jpeg, .png"
              accept={["jpg", "jpeg", "png"]}
              show={false}
              files={selectedImageUrl}
              setFiles={onFileChanges}
              images={true}
              forceRemount={forceRemount}
            />
            <HStack flex={1} flexWrap={"wrap"}>
              {selectedImageUrl && (
                <ViewUploadImageCards
                  ind={0}
                  url={selectedImageUrl}
                  onDeleteImage={onDeleteImage}
                />
              )}
            </HStack>
          </>
        ) : (
          <InputField
            name="video_notification"
            value={videoUrl}
            placeholder="Enter your video link here"
            onChange={(e) => {
              let value = e.target.value;
              // let d = { ...data };
              // d.url = value;
              setVideoUrl(value);
              // setData(d);
            }}
            forceRemount={forceRemount}
          />
        )}
      </VStack>
    );
  }
);
